<template>
  <div class="grid-view">
    <div class="main-content">
      <search-item
        ref="searchItem"
        :auto-init="true"
        :show-more-scheme="true"
        :show-simple="true"
        :expand-adv="true"
        :custom-search-items="customSearchItems"
        :search-item-code="$t('CargoMsg.Cargo_BusinessCommission')"
        config-module="1600"
        @query="queryHandler"
      >
        <template slot="operations">
          <c-a-btn-group source-view="businessCommission" :job="job" :hp="cABusinessCommissionHP" />
        </template>
      </search-item>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          v-if="visible"
          config-module="1600001"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
        />
      </div>
      <div class="pagination-wrapper">
        <div style="display: flex;justify-content: flex-end;flex-wrap: wrap">
          <span v-show="showSelectionCount">
            {{ selectionCountLabel }}
          </span>
          <charge-currency-total-group
            v-if="reCalc"
            :key="1"
            :amount-to-currency="localCurrency"
            mode="simple"
            data-field="income"
            type="both"
            :data-provider="cABusinessCommissionHP.totalProfits"
            currency-field="currency"
            :amount-to-currency-label="$t('CargoMsg.Cargo_Receivable')"
          />
          <charge-currency-total-group
            v-if="reCalc"
            :key="2"
            :amount-to-currency="localCurrency"
            mode="simple"
            data-field="cost"
            type="both"
            :data-provider="cABusinessCommissionHP.totalProfits"
            currency-field="currency"
            :amount-to-currency-label="$t('CargoMsg.Cargo_Dues')"
          />
          <charge-currency-total-group
            v-if="reCalc"
            :key="3"
            :amount-to-currency="localCurrency"
            mode="simple"
            data-field="realProfit"
            type="both"
            :data-provider="cABusinessCommissionHP.totalProfits"
            currency-field="currency"
            :amount-to-currency-label="$t('CargoMsg.Cargo_Profit')"
          />
        </div>
        <cargo-pagination
          :total="searchConditions.total"
          :page.sync="searchConditions.pageNum"
          :limit.sync="searchConditions.pageSize"
          @pagination="queryPageHandler"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { DocumentManage } from '@/utils/commonUtil'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import { events } from './cABusinessCommissionHP'
import * as LoadDefaultQueryParam from '@/utils/LoadDefaultQueryParam'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import OperatorConstants from '@/class/cargo/model/parameters/OperatorConstants'
import * as AdvancedSearchConsts from '@/class/cargo/model/utils/AdvancedSearchConsts'
import * as ChargeConstants from '@/class/cargo/model/parameters/ChargeConstants'
import lodash from 'lodash'
import cABtnGroup from './cABtnGroup'
import ChargeCurrencyTotalGroup from '@/components/Cargo/Act/chargeSummary/ChargeCurrencyTotalGroup.vue'
import CABusinessCommissionHP from '@/views/cargo/v0/Clearing/components/ClosingAccount/cABusinessCommissionHP'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import { LOG_CARRY_FORWARD } from '@/class/cargo/model/parameters/SystemConstants'
// todo 高级查询条件待生成
export default {
  name: 'BusinessCommission',
  components: { searchItem, cABtnGroup, ChargeCurrencyTotalGroup },
  props: {
    visible: { type: Boolean, required: true },
    customConditions: { type: Array, default: () => [] },
    jobStates: { type: Array, default: () => [] }, // 业务状态
    isAr: { type: Number, default: -1 }, // 是否有付款申请
    hasBillPayment: { type: Number, default: -1 }, // 是否应收
    hasCheckRole: { type: Number, default: -1 }, // 是否根据权限查询数据
    showRevenueColumn: { type: Boolean, default: true }, // 是否显示总收入
    showCostColumn: { type: Boolean, default: true }, // 是否显示总成本
    jobStateParam: { type: String, default: '' }
  },
  data() {
    return {
      localCurrency: 'RMB',
      reCalc: true,
      customSearchItems: [], // 自定义高级查询项
      allJobByRole: false, // 查看所有业务
      departmentJobByRole: false, // 查看同组业务
      userJobByRole: false, // 查看自己业务
      departmentTeamUser: [], // 同部门的人
      showTotalProfit: true, // 显示总利润 (全量数据)
      searchConditions: {
        total: 0, // total传递到后端无用
        pageNum: 1,
        pageSize: 50,
        likeName: '', // 模糊查询名称
        simpleTriggerMode: false, // 是否为简单查询触发模式
        snapshotConditions: [], // 高级查询条件（点击查询时的快照状态）
        requires: ['showTotalProfit', 'revenue']
      },
      job: {}, // todo
      cABusinessCommissionHP: new CABusinessCommissionHP(this), // todo 测试该对象的property是否为 reactive**
      documentManage: new DocumentManage(),
      gridOptions: {
        defaultColDef: {
          filter: false
        }
      },
      gridParams: {},
      columnDefs: [],
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      rowData: [],
      showSelectionCount: true,
      selectionCountLabel: '',
      location: LOG_CARRY_FORWARD.code
    }
  },
  watch: {
    async visible(newVal) {
      if (newVal) {
        await this.cABusinessCommissionHP.initializeHandler()
      }
    }
  },
  beforeCreate() {
    // 不需要设为reactive
    // this._businessCommissionHP = new BusinessCommissionHP(this)
  },
  async created() {
    this.cABusinessCommissionHP.created()
    await this.cABusinessCommissionHP.initializeHandler()
    this.initEvents()
    this.setLocalCurrency()
  },
  beforeMount() {
    const cxt = this
    this.documentManage.set('showDetailView4Business', function(uuid) {
      const data = cxt.rowData.find(item => item.uuid === uuid)
      cxt.showDetailView4Business({ data })
    })
  },
  beforeDestroy() {
    this.$off()
    this.documentManage.destory()
  },
  methods: {
    filterChange() {
      this.$nextTick(() => {
        const hasDisplay = []
        this.gridOptions.api.forEachNode(node => {
          if (node.displayed) {
            hasDisplay.push(node.data)
          }
        })
        if (hasDisplay.length > 0) {
          if (hasDisplay.length === this.rowData.length) {
            this.showTotalProfit = true
          }
          if (hasDisplay.length < this.rowData.length) {
            this.showTotalProfit = false
          }
        } else {
          this.showTotalProfit = false
        }
        this.cABusinessCommissionHP.refreshSelectedCount()
      })
    },
    initEvents() {
      // todo
      this.$on(events.BACK_TO_FINANCE_MANAGE, this.backManageList)
    },
    queryHandler({ simpleTriggerMode, conditions }) {
      this.searchConditions.pageNum = 1
      const finallyConditions = []
      this.searchConditions.simpleTriggerMode = simpleTriggerMode
      if (this.searchConditions.simpleTriggerMode) {
        const option = new AdvancedSearchOption(null, 'job.job_no', conditions.trim(), OperatorConstants.OPERATOR_LIKE.code)
        finallyConditions.push(option.formatObj2Json())
      } else {
        // 高级查询条件组装
        const advConditions = lodash.cloneDeep(conditions)

        if (AdvancedSearchOption.hasField('charge.offset_state', advConditions)) {
          const offsetStateOption = AdvancedSearchOption.getOption('charge.offsetState', advConditions)
          if (offsetStateOption.value === false) {
            offsetStateOption.value = ChargeConstants.OFFSET_STATE_NORMAL.code
          } else {
            offsetStateOption.operator = AdvancedSearchConsts.OPERATOR_IN.code
            offsetStateOption.value = [ChargeConstants.OFFSET_STATE_HEDGE.code, ChargeConstants.OFFSET_STATE_BE_HEDGE.code]
          }
          AdvancedSearchOption.updateOption(advConditions, advConditions)
        }
        finallyConditions.push(...advConditions)
      }
      this.toSupplementConditionsBeforeQuery(finallyConditions)
      // 条件保存
      this.searchConditions.snapshotConditions = finallyConditions
      // this.cABusinessCommissionHP.doSearch()
      this.cABusinessCommissionHP.doSearchWithProfitAndList()
    },
    toSupplementConditionsBeforeQuery(finallyConditions) {
      if (this.customConditions && this.customConditions.length > 0) { finallyConditions.push(...this.customConditions) }

      if (this.jobStates && this.jobStates.length > 0 && !LoadDefaultQueryParam.isSelectOption(finallyConditions, 'job.job_state')) {
        const option = new AdvancedSearchOption(null, 'job.job_state', LoadDefaultQueryParam.convertCommonStateToInt(this.job_states), AdvancedSearchConsts.OPERATOR_IN.code)
        finallyConditions.push(option.formatObj2Json())
      } else if (!AdvancedSearchOption.hasField('job.job_state', finallyConditions)) {
        const option = new AdvancedSearchOption(null, 'job.job_state', LoadDefaultQueryParam.convertCommonStateToInt(SystemConstants.JOB_STATES), AdvancedSearchConsts.OPERATOR_IN.code)
        finallyConditions.push(option.formatObj2Json())
      }

      if (this.isAr !== -1) { finallyConditions.push(new AdvancedSearchOption(null, 'charge.receivable', this.isAr === 1).formatObj2Json()) }

      const requires = []
      if (this.showRevenueColumn || this.showCostColumn) { requires.push('revenue') }
      requires.push('commission')
      this.searchConditions.requires = requires
    },
    queryPageHandler() {
      // 间接使用 查询按钮点击时的查询条件快照
      this.cABusinessCommissionHP.doSearch()
    },
    backManageList() {
      this.$emit('update:visible', false)
    },
    async showDetailView4Business({ data } = {}, needChecked = false) {
      const r = await this.cABusinessCommissionHP.showDetailView(needChecked, { ...data }, this.gridOptions, this.rowData, 'businessCommissionList')
      this.$emit('viewDetail', r)
      this.$emit('update:visible', false)
    },
    setLocalCurrency() {
      this.localCurrency = RateUtil.localCurrencyByOffice()
      if (this.localCurrency !== 'RMB') {
        setTimeout(() => { this.reCalc = false }, 100)
        setTimeout(() => { this.reCalc = true }, 100)
      }
    }
  }
}
</script>

<style scoped>

</style>
